import { graphql } from "gql.tada";

const ModifyProjectMut = graphql(`
  mutation modifyProject($input: UpdateProjectInput!) {
    modifyProject(input: $input) {
      status
      message
    }
  }
`);

const ProjectCreateMut = graphql(`
  mutation addProject($input: CreateProjectInput!) {
    addProject(input: $input) {
      title
      id
      constructionTitle
      createdAt
      updatedAt
      description
      projectNumber
      version
      status {
        status
        color
      }
      unit {
        unit
        color
      }
      country
      projectNodes {
        id
        parentId
        kind
        position
        folderName
        folderDescription
        originId
        productName
        productDescription
        pimId
        characteristic
        orderCode
        foldedOrderCode
        presentation
        quantity
        wizardLink
        customerReference
        configuratorType
        version
        info
        enabled
        freeSlots
        type
        price
        priceGroup
      }
      owner {
        id
        externalId
        fullName
        email
        lastName
        firstName
      }
      sharedWith {
        id
        fullName
        email
        lastName
        firstName
      }
      lastEditBy {
        id
        fullName
        email
        lastName
        firstName
      }
    }
  }
`);

const SameProjectCreateMut = graphql(`
  mutation addSameProject($input: CreateSameProjectInput!) {
    addSameProject(input: $input) {
      title
      id
      constructionTitle
      createdAt
      updatedAt
      description
      projectNumber
      version
      mandator
      status {
        status
        color
      }
      unit {
        unit
        color
      }
      country
      projectNodes {
        id
        parentId
        kind
        position
        folderName
        folderDescription
        originId
        productName
        productDescription
        pimId
        characteristic
        orderCode
        foldedOrderCode
        presentation
        quantity
        wizardLink
        customerReference
        configuratorType
        version
        info
        enabled
        freeSlots
        type
        price
        priceGroup
      }
      owner {
        id
        externalId
        fullName
        email
        lastName
        firstName
      }
      sharedWith {
        id
        fullName
        email
        lastName
        firstName
      }
      lastEditBy {
        id
        fullName
        email
        lastName
        firstName
      }
    }
  }
`);

const ProjectStatusUpdateMut = graphql(`
  mutation modifyProject($input: UpdateProjectInput!) {
    modifyProject(input: $input) {
      status
      message
    }
  }
`);

const MultipleProjectsDeleteMut = graphql(`
  mutation removeProjects($input: RemoveProjectsInput!) {
    removeProjects(input: $input) {
      deletedIds
      undeletedIds
      errors
      __typename
    }
  }
`);

const DuplicateWizardInProjectMut = graphql(`
  mutation replicateWizard($input: ReplicateWizardInput!) {
    replicateWizard(input: $input) {
      status
      message
    }
  }
`);

// Todo, implement mailingId when AB is ready
const DuplicateProjectMut = graphql(`
  mutation replicateProject($input: DuplicateProjectInput!) {
    replicateProject(input: $input) {
      title
      id
      constructionTitle
      createdAt
      updatedAt
      description
      projectNumber
      version
      status {
        status
        color
      }
      unit {
        unit
        color
      }
      country
      projectNodes {
        id
        parentId
        kind
        position
        folderName
        folderDescription
        originId
        productName
        productDescription
        pimId
        characteristic
        orderCode
        foldedOrderCode
        presentation
        quantity
        wizardLink
        customerReference
        configuratorType
        version
        info
        enabled
        freeSlots
        type
        price
        priceGroup
      }
      owner {
        id
        externalId
        fullName
        email
        lastName
        firstName
      }
      sharedWith {
        id
        fullName
        email
        lastName
        firstName
      }
      lastEditBy {
        id
        fullName
        email
        lastName
        firstName
      }
    }
  }
`);

const ShareProjectMut = graphql(`
  mutation shareProject($input: ShareProjectInput!) {
    shareProject(input: $input) {
      message
      status
    }
  }
`);

const TroxnetUploadXmlMut = graphql(`
  mutation uploadTroxNetComWizard($input: UploadTroxNetComWizardInput!) {
    uploadTroxNetComWizard(input: $input) {
      status
      message
    }
  }
`);

const GenerateReportArchiveMut = graphql(`
  mutation generateReportArchive($input: GenerateReportArchiveInput!) {
    generateReportArchive(input: $input) {
      requestId
    }
  }
`);

export {
  ProjectCreateMut,
  SameProjectCreateMut,
  ProjectStatusUpdateMut,
  MultipleProjectsDeleteMut,
  DuplicateProjectMut,
  TroxnetUploadXmlMut,
  GenerateReportArchiveMut,
  ShareProjectMut,
  ModifyProjectMut,
  DuplicateWizardInProjectMut,
};
